import styled from 'styled-components'
import { Box } from 'pcln-design-system'

export const SliderSectionWrapper = styled(Box)`
  @media screen and (max-width: 1023px) {
    touch-action: pan-y;
    .rc-slider-handle {
      width: 28px !important;
      height: 28px !important;
      margin-left: -14px !important;
      margin-top: -13px !important;
    }
  }
`
